// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../_redux/adminDashboard/adminDashboardActions";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../../_metronic/_helpers";
import * as uiHelpers from "./AdminDashboardUIHelpers";

import { Pagination } from "../../../../../_metronic/_partials/controls";
import { useUnknownEmailSenderUIContext } from "./UnknownEmailSenderUiContext";
import { DateTimeFormatter } from "../../../formatters/CustomFormatters";

import {
  UnknownEmailErrorType,
  UnknownEmailSenderTableAction,
} from "./UnknownEmailSenderTableAction";
export default function UnknownEmailSenderTable() {
  // Customers UI Context
  const adminDashboardUIContext = useUnknownEmailSenderUIContext();
  const adminDashboardUIProps = useMemo(() => {
    return {
      queryParams: adminDashboardUIContext.queryParams,
      setQueryParams: adminDashboardUIContext.setQueryParams,
    };
  }, [adminDashboardUIContext]);

  // Getting curret state of customers list from store (Redux)
  const { adminDashboard } = useSelector((state) => state, shallowEqual);

  const {
    unknownEmailSenderlistLoading,
    totalCountUnknownEmailSender,
    unknownEmailSenders,
  } = adminDashboard;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      actions.fetchUnknownEmailSender(adminDashboardUIProps.queryParams)
    );
  }, [adminDashboardUIProps.queryParams, dispatch]);
  // Table columns
  const columns = [
    {
      dataField: "errorType",

      text: "error Type",
    },
    {
      dataField: "time",
      formatter: DateTimeFormatter,
      text: "time",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "errorMsg",
      text: "email",
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: UnknownEmailSenderTableAction,
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCountUnknownEmailSender,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: adminDashboardUIProps.queryParams.pageSize,
    page: adminDashboardUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={unknownEmailSenderlistLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                bordered={false}
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                remote
                keyField="_id"
                data={unknownEmailSenders === null ? [] : unknownEmailSenders}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  adminDashboardUIProps.setQueryParams
                )}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={unknownEmailSenders} />
                <NoRecordsFoundMessage entities={unknownEmailSenders} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
